import React from "react";
import {InputAdornment, TextField} from "@mui/material";
import {grey} from "@mui/material/colors";
import {HugeiconsIcon} from "@hugeicons/react";
import {Search01Icon} from "@hugeicons/core-free-icons";

// Rounded search field used in page headers (same look as the Projects page search)
const SearchInput = ({value, onChange, placeholder = "Search...", sx}) => {
  return (
    <TextField
      size={"small"}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position={"start"}>
            <HugeiconsIcon icon={Search01Icon} size={18} color={grey[500]}/>
          </InputAdornment>
        ),
      }}
      sx={{
        flex: 1,
        maxWidth: {md: 420},
        ml: {md: "auto"},
        "& .MuiOutlinedInput-root": {
          borderRadius: "20px",
          bgcolor: grey[100],
          fontSize: 14,
          "& fieldset": {border: "none"},
          "&:hover": {bgcolor: grey[200]},
          "&.Mui-focused": {bgcolor: "#fff", "& fieldset": {border: `1px solid ${grey[300]}`}},
        },
        ...sx,
      }}
    />
  );
};

export default SearchInput;
